export const SERVER_VALUE_YES = 'Y';
export const SERVER_VALUE_NO = 'N';
export const SERVER_VALUE_YES_LOWERCASE = 'y';
export const SERVER_VALUE_NO_LOWERCASE = 'n';

export const HTTP_METHOD_PATCH = 'PATCH';
export const HTTP_METHOD_POST = 'POST';
export const CHEMO_RECORDS_ENDPOINT = '/chemo/records';
export const SEND_CUSTOMER_MESSAGE_ENDPOINT = '/chemo/send-customer-message';

export const EMPTY_STRING = '';
export const ERROR_SPLIT_DELIMITER = '2';
export const FINISHED_STATUS_HEB = 'סיים';
export const COUNT_PLACEHOLDER = '{count}';
export const DASH_PLACEHOLDER = '-';
export const CHECK_MARK = '✓';

export const ISO_DATE_SEPARATOR = 'T';
export const DATE_REGEX_ISO = /^\d{4}-\d{2}-\d{2}$/;
export const DATE_REGEX_ISO_PREFIX = /^(\d{4}-\d{2}-\d{2})/;
export const PAD_LENGTH = 2;
export const PAD_CHAR = '0';
export const HOUR_ZERO = 0;
export const MINUTE_ZERO = 0;
export const SECOND_ZERO = 0;
export const MILLISECOND_ZERO = 0;
export const MONTH_OFFSET = 1;
export const DATE_PART_INDEX = 0;

export const FIELD_NAMES = {
    APPROVED: 'APPROVED',
    NOT_APPROVED: 'NOTAPPROVED',
    FINISH: 'FINISH',
    TO_DUE_DATE: 'TODUEDATE',
    ROW_ID: 'KLINE2',
    KLINE: 'KLINE',
    LOADED: 'LOADED',
    DUEDATE1: 'DUEDATE1',
    DUEDATE: 'DUEDATE',
    SPECVALUE: 'SPECVALUE',
    FROMDATE: 'FROMDATE',
    TODATE: 'TODATE',
    SNAME: 'SNAME',
    SUBFORM: 'NEO_PARTDUEDATE_LINE_SUBFORM',
    DAY: 'DAY',
    CUSTDES: 'CUSTDES',
    CUSTNAME: 'CUSTNAME',
    CDES: 'CDES',
    ORDNAME: 'ORDNAME',
    ORDBAL: 'ORDBAL',
    ORDI1: 'ORDI1'
};

export const TOP_RECORDS_OPTIONS = [5, 8, 12];

// Hospitals allowed to edit the delivery date (TODUEDATE) directly in the form.
// Configured via REACT_APP_HOSPITALS_WITH_DATE_EDIT env var (comma-separated).
// All others see a "contact customer service" message instead.
export const HOSPITALS_WITH_DATE_EDIT = (process.env.REACT_APP_HOSPITALS_WITH_DATE_EDIT || '')
    .split(',')
    .map(h => h.trim())
    .filter(Boolean);

export const CHEMO_DEFAULTS = {
    TOP_RECORDS: 8,
    DAYS_AHEAD: 10,
    TREATMENT_TYPE: '3',
    PRODUCT_CODE: 'Z-0026'
};
